import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { AppConstant, ImageConstant, LangConstant } from "const";

const SetAvatarForm = ({ onSubmitImageForm, onAvatarInputChange, avatarErrorMsg, avatar }) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_LOGIN);

  return (
    <form
      onSubmit={onSubmitImageForm}
      style={{
        maxWidth: 346,
        width: "100%",
        minHeight: 216,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
        margin: "56px auto",
      }}
    >
      <label
        style={{
          position: "relative",
          display: "block",
          margin: "0 auto",
          width: 120,
          height: 120,
          borderRadius: "50%",
          overflow: "hidden",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          cursor: "pointer",
        }}
      >
        <input
          type="file"
          accept={AppConstant.ACCEPTABLE_IMAGE_TYPES.join(",")}
          onChange={onAvatarInputChange}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: "100%",
            height: "100%",
            cursor: "pointer",
          }}
        />
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#F5F5F5",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundImage: `url(${avatar.previewAvatar ? avatar.previewAvatar : ImageConstant.AddAvatarIcon})`,
              backgroundSize: avatar.previewAvatar ? "cover" : "16%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          />
        </div>
      </label>

      {!avatar.previewAvatar && (
        <p style={{ textAlign: "center", fontSize: 15, lineHeight: "20px", margin: "14px 0", fontWeight: 600 }}>
          {getLabel(LangConstant.TXT_ADD_AVATAR)}
        </p>
      )}

      <button
        type="submit"
        className="btn btn-primary w-100"
        disabled={avatar.previewAvatar === null}
        style={{ minHeight: 40, borderRadius: 4, fontSize: 15, lineHeight: "20px", fontWeight: 600 }}
      >
        {getLabel(LangConstant.L_CONTINUE_BUTTON)}
      </button>

      {avatarErrorMsg && (
        <small className="d-block text-center text-danger" style={{ paddingTop: 7 }}>
          {avatarErrorMsg}
        </small>
      )}
    </form>
  );
};

SetAvatarForm.prototype = {
  avatar: PropTypes.object,
  onSubmitImageForm: PropTypes.func,
  onAvatarInputChange: PropTypes.func,
  avatarErrorMsg: PropTypes.string,
};

export default SetAvatarForm;
